// src/components/common/Toast.tsx
import React from 'react';
import { ToastContainer, toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const defaultOptions: ToastOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
};

export const showSuccessToast = (message: string, options: ToastOptions = {}) => {
    toast.success(message, { ...defaultOptions, ...options });
};

export const showErrorToast = (message: string, options: ToastOptions = {}) => {
    toast.error(message, { ...defaultOptions, ...options });
};

export const showInfoToast = (message: string, options: ToastOptions = {}) => {
    toast.info(message, { ...defaultOptions, ...options });
};

export const showWarningToast = (message: string, options: ToastOptions = {}) => {
    toast.warning(message, { ...defaultOptions, ...options });
};

// This container must be mounted once in the App root
export const Toast: React.FC = () => {
    return <ToastContainer />;
};